export const getRequirementsSets = state => state.search.requirementsSets;
export const getIsSearching = state => state.search.isSearching;
export const getMetaData = state => state.search.meta;